import axios from "axios";

export const state = {
  cached: "",
};

export const getters = {};

export const mutations = {};

export const actions = {
  async createBlob(
    { commit, state, rootState },
    {
      txInitiator,
      masterWeight,
      txThreshold,
      signers,
      jointAccountAddress,
      jointAccountPrivKey,
    }
  ) {
    return axios
      .post(`/ztx/multisig/generate-blob/create`, {
        txInitiator,
        masterWeight,
        txThreshold,
        signers,
        jointAccountAddress,
        jointAccountPrivKey,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        if (error.response.data.messages[0] != null) {
          return error.response.data.messages[0];
        }
        return error;
      });
  },

  async signBlob({ commit, state, rootState }, { hash, blob, privateKeys }) {
    return axios
      .post(`/ztx/tx/sign-blob`, {
        hash,
        blob,
        privateKeys,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async submitTx({ commit, state, rootState }, { hash, blob, listSigner }) {
    return axios
      .post(`/ztx/tx/submit`, {
        hash,
        blob,
        listSigner,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        if (error.response.data.messages[0] != null) {
          return error.response.data.messages[0];
        }
        return error;
      });
  },

  async importAccount(
    { commit, state, rootState },
    { jointAddress, jointName, signersName }
  ) {
    return axios
      .post(`/ztx/multisig/account/import`, {
        jointAddress,
        jointName,
        signersName,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        return error.response.data;
      });
  },

  async getJointAddressList({ commit, state, rootState }, { zetrixAccount }) {
    if (zetrixAccount && zetrixAccount.length > 0) {
      return axios
        .get(`/ztx/multisig/v2/account/bySigner?address=${zetrixAccount}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async getAccountInfo({ commit, state, rootState }, { jointAddress }) {
    if (jointAddress && jointAddress.length > 0) {
      return axios
        .get(`/ztx/multisig/v2/account?address=${jointAddress}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async updateBlob(
    { commit, state, rootState },
    {
      txInitiator,
      jointAddress,
      masterWeight,
      txThreshold,
      signers,
      newSignersName,
    }
  ) {
    return axios
      .post(`/ztx/multisig/generate-blob/update`, {
        txInitiator,
        jointAddress,
        masterWeight,
        txThreshold,
        signers,
        newSignersName,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async getTxHistory({ commit, state, rootState }, { queryValue }) {
    if (queryValue && queryValue.length > 0) {
      return axios
        .get(`/ztx/multisig/tx/history/signed${queryValue}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async getTxHistoryGeneral({ commit, state, rootState }, { queryValue }) {
    if (queryValue && queryValue.length > 0) {
      return axios
        .get(`/ztx/multisig/tx/history${queryValue}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async getBlob({ commit, state, rootState }, { blobId }) {
    if (blobId && blobId.length > 0) {
      return axios
        .get(`/ztx/multisig/blob?blobId=${blobId}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async parseBlob({ commit, state, rootState }, { blob }) {
    return axios
      .post(`/ztx/tx/parse-blob`, {
        blob,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async addSignBlob(
    { commit, state, rootState },
    { blobId, signBlob, publicKey }
  ) {
    return axios
      .post(`/ztx/multisig/sign/add`, {
        blobId,
        signBlob,
        publicKey,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async getSignHistory({ commit, state, rootState }, { queryValue }) {
    if (queryValue && queryValue.length > 0) {
      return axios
        .get(`/ztx/multisig/sign/history${queryValue}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async submit({ commit, state, rootState }, { blobId }) {
    return axios
      .post(`/ztx/multisig/submit`, {
        blobId,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        if (error.response.data.messages[0] != null) {
          return error.response.data.messages[0];
        }
        return error;
      });
  },

  async createBlobTx(
    { commit, state, rootState },
    { txInitiator, operations, jointAddress }
  ) {
    return axios
      .post(`/ztx/multisig/generate-blob/tx`, {
        txInitiator,
        operations,
        jointAddress,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async createBlobContract(
    { commit, state, rootState },
    { txInitiator, contractAddress, jointAddress, method, inputParameters, metadata }
  ) {
    return axios
      .post(`/ztx/multisig/generate-blob/contract`, {
        txInitiator,
        contractAddress,
        jointAddress,
        method,
        inputParameters,
        metadata,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async createBlobZtp20(
    { commit, state, rootState },
    { txInitiator, contractAddress, jointAddress, method, inputParameters, metadata }
  ) {
    return axios
      .post(`/ztx/multisig/generate-blob/ztp20`, {
        txInitiator,
        contractAddress,
        jointAddress,
        method,
        inputParameters,
        metadata,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async updateStatusCancel({ commit, state, rootState }, { pathValue }) {
    if (pathValue && pathValue.length > 0) {
      return axios
        .put(`/ztx/multisig/update/blob-cancel/${pathValue}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async overwriteBlobTx({ commit, state, rootState }, { pathValue }) {
    if (pathValue && pathValue.length > 0) {
      return axios
        .put(`/ztx/multisig/update/blob-overwrite/${pathValue}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async checkUpdateBlob(
    { commit, state, rootState },
    {
      txInitiator,
      jointAddress,
      masterWeight,
      txThreshold,
      signers,
      newSignersName,
    }
  ) {
    return axios
      .post(`/ztx/multisig/check-blob/update`, {
        txInitiator,
        jointAddress,
        masterWeight,
        txThreshold,
        signers,
        newSignersName,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        if (error.response.data.messages[0] != null) {
          return error.response.data.messages[0];
        }
        return error;
      });
  },

  async checkBlobTx(
    { commit, state, rootState },
    { txInitiator, operations, jointAddress }
  ) {
    return axios
      .post(`/ztx/multisig/check-blob/tx`, {
        txInitiator,
        operations,
        jointAddress,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        if (error.response.data.messages[0] != null) {
          return error.response.data.messages[0];
        }
        return error;
      });
  },

  async checkBlobContract(
    { commit, state, rootState },
    { txInitiator, contractAddress, jointAddress, method, inputParameters, metadata }
  ) {
    return axios
      .post(`/ztx/multisig/check-blob/contract`, {
        txInitiator,
        contractAddress,
        jointAddress,
        method,
        inputParameters,
        metadata,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async checkBlobUpgradeContent(
    { commit, state, rootState },
    { contractCode, contractAddress, jointAddress, txInitiator, metadata }
  ) {
    return axios
      .post(`/ztx/multisig/check-blob/upgrade-contract/content`, {
        contractCode,
        contractAddress,
        jointAddress,
        txInitiator,
        metadata,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async checkBlobUpgradeOwner(
    { commit, state, rootState },
    { newOwner, contractAddress, jointAddress, txInitiator, metadata }
  ) {
    return axios
      .post(`/ztx/multisig/check-blob/upgrade-contract/owner`, {
        newOwner,
        contractAddress,
        jointAddress,
        txInitiator,
        metadata,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async createBlobUpgradeContent(
    { commit, state, rootState },
    { contractCode, contractAddress, txInitiator, jointAddress, metadata }
  ) {
    return axios
      .post(`/ztx/multisig/generate-blob/upgrade-contract/content`, {
        contractCode,
        contractAddress,
        txInitiator,
        jointAddress,
        metadata,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async createBlobUpgradeOwner(
    { commit, state, rootState },
    { newOwner, contractAddress, txInitiator, jointAddress, metadata }
  ) {
    return axios
      .post(`/ztx/multisig/generate-blob/upgrade-contract/owner`, {
        newOwner,
        contractAddress,
        txInitiator,
        jointAddress,
        metadata,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async getPendingTxList(
    { commit, state, rootState },
    {
      jointAddress,
      address,
      keyWords,
      purpose,
      createdDate,
      pageSize,
      page,
      isAsc,
      sort,
    }
  ) {
    return axios
      .post(`/ztx/multisig/tx/history/pending`, {
        jointAddress,
        address,
        keyWords,
        purpose,
        createdDate,
        pageSize,
        page,
        isAsc,
        sort,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async getCompletedTxList(
    { commit, state, rootState },
    {
      jointAddress,
      address,
      keyWords,
      purpose,
      createdDate,
      pageSize,
      page,
      isAsc,
      sort,
    }
  ) {
    return axios
      .post(`/ztx/multisig/tx/history/completed`, {
        jointAddress,
        address,
        keyWords,
        purpose,
        createdDate,
        pageSize,
        page,
        isAsc,
        sort,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async getTxDetail({ commit, state, rootState }, { blobId: blobId }) {
    if (blobId && blobId.length > 0) {
      return axios
        .get(`/ztx/multisig/tx/detail?blobId=${blobId}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async getSignRecord({ commit, state, rootState }, { blobId: blobId }) {
    if (blobId && blobId.length > 0) {
      return axios
        .get(`/ztx/multisig/sign/record?blobId=${blobId}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async rejectSignBlob(
    { commit, state, rootState },
    { blobId, address }
  ) {
    return axios
      .post(`/ztx/multisig/sign/reject`, {
        blobId,
        address,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async withdrawSignBlob(
    { commit, state, rootState },
    { blobId, address }
  ) {
    return axios
      .post(`/ztx/multisig/sign/withdraw`, {
        blobId,
        address,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },
};
